import { Breadcrumbs } from '@logz-ui/styleguide';
import { useBreadcrumbs } from 'ui/state/hooks/breadcrumbs.state.hook';

export const HeaderBreadcrumbs = () => {
  const { crumbs, customCrumb } = useBreadcrumbs();

  return <Breadcrumbs crumbs={crumbs ?? []} customCrumb={customCrumb ?? undefined} />;
};
